import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CancelQuote } from '../../models/cancel-data.model';
import { jsPDF } from 'jspdf';
import { Contract } from '../../models/contract.interface';
import { CancelCalculation } from '../../models/cancel-calculations.model';

@Component({
  selector: 'app-quote-data',
  templateUrl: './quote-data.component.html',
  styleUrls: ['./quote-data.component.css']
})
export class QuoteDataComponent {
  @Input() reference!: number;
  @Input() cancelQuote?: CancelCalculation;
  @Input() selectedContract?: Contract;
  @Input() canceledAt?: Date | string | null;
  @Input() cancellationMileage?: number | null;
  @Input() quoteGeneratedAt?: Date | string;
  @Input() hideRefundToDealership: boolean = false;
  @Output() onQuoteReset = new EventEmitter<void>();
  @Output() onQuoteSend = new EventEmitter<void>();
  isTermsChecked: boolean = false;

  constructor() { }

  handleNewQuoteClick(): void {
    this.onQuoteReset.emit();
  }

  handleSendQuoteClick(): void {
    this.onQuoteSend.emit();
  }

  handlePrint(): void {
    var doc = new jsPDF();
    var elementHTML = document.createElement('div');
    elementHTML.innerHTML = document.getElementById('print-section')?.innerHTML!!;
    elementHTML?.removeAttribute('hidden');
    elementHTML.style.letterSpacing = '0.03px';
    elementHTML.style.width = '100%';

    elementHTML.style.transform = 'scale(1)';
    elementHTML.style.transformOrigin = 'top left';

    if (this.hideRefundToDealership) {
      elementHTML.querySelectorAll('.refund-to-dealership-row').forEach(el => el.remove());
    }

    doc.html(elementHTML, {
      callback: function (doc) {
        window.open(doc.output('bloburl'), '_blank');
      },
      x: 5,
      y: 5,
      width: 190,
      windowWidth: 1500,
    });
  }
}
